var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","transform":"translate(0 -7)"},[React.createElement("rect",{"width":"26","height":"3","y":"7","key":0}),React.createElement("rect",{"width":"26","height":"3","y":"15","key":1}),React.createElement("rect",{"width":"26","height":"3","y":"24","key":2})]));
}

HamburgerInline.defaultProps = {"width":"26","height":"20","viewBox":"0 0 26 20","fill":"currentColor"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
